import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import BottomMenuBox from '../component/BottomMenuBox';

const MainLayout = () => {
  return (
    <>
      <LS.Wrap>
        <LS.MainCntAreaLayout>
          <Outlet />
        </LS.MainCntAreaLayout>
        <BottomMenuBox />
      </LS.Wrap>
    </>
  );
};

export default MainLayout;
